// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.workbook-dialog-import-file-field__file-label {
  overflow: hidden;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/CollectionsStructure/CreateWorkbookDialog/ImportFileField/ImportFileField.scss"],"names":[],"mappings":"AACI;EACI,gBAAA;AAAR","sourcesContent":[".workbook-dialog-import-file-field__file-label {\n  overflow: hidden;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
